import ApiService from "../api";

export default class NotificacaoService extends ApiService {

    constructor() {
        super('/api/notificacoes')
    }

    listarMinhas(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        const query = params.toString();
        return this.get(query ? `?${query}` : ``)
    }

    contarNaoLidas() {
        return this.get(`/nao-lidas/quantidade`)
    }

    marcarComoLida(id) {
        return this.patch(`/${id}/lida`)
    }

    marcarTodasComoLidas() {
        return this.patch(`/lidas`)
    }
}
